import React, { useEffect } from 'react';
import {
  Typography,
  TextField,
  Switch,
  FormControlLabel,
  Card,
  CardContent,
  Grid,
  Divider,
  Box,
  InputAdornment
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getPaymentMethods, editArray } from '../store/slices/currencySlice';
import { editSettings } from '../store/slices/settingsSlice';

const CryptoCurrencySetting = () => {
  const dispatch = useDispatch();
  const paymentMethods = useSelector((state) => state.paymentMethod.paymentMethods);
  const settings = useSelector((state) => state.settings.settings);

  useEffect(() => {
    dispatch(getPaymentMethods());
  }, [dispatch]);

  const handlePaymentMethodChange = (paymentMethodId, field, value) => {
    dispatch(editArray({
      id: paymentMethodId,
      [field]: value
    }));
  };

  const handleZpubChange = (settingName, value) => {
    const setting = settings.find(s => s.name === settingName);
    if (setting) {
      dispatch(editSettings({
        ...setting,
        value: value
      }));
    }
  };

  const getZpubValue = (paymentMethod) => {
    const settingName = `${paymentMethod.value}_ZPUB`;
    const setting = settings.find(s => s.name === settingName);
    return setting ? setting.value : '';
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Настройки криптовалют
      </Typography>
      
      {paymentMethods.map((paymentMethod) => (
        <Card key={paymentMethod.id} sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              {paymentMethod.label} ({paymentMethod.value})
            </Typography>
            
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={paymentMethod.is_active || false}
                      onChange={(e) => handlePaymentMethodChange(paymentMethod.id, 'is_active', e.target.checked)}
                    />
                  }
                  label="Активна"
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Комиссия"
                  type="number"
                  value={paymentMethod.commission || 0}
                  onChange={(e) => handlePaymentMethodChange(paymentMethod.id, 'commission', parseFloat(e.target.value))}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Минимальная сумма"
                  type="number"
                  value={paymentMethod.min_amount || 0}
                  onChange={(e) => handlePaymentMethodChange(paymentMethod.id, 'min_amount', parseFloat(e.target.value))}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">{paymentMethod.value}</InputAdornment>,
                  }}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Максимальная сумма"
                  type="number"
                  value={paymentMethod.max_amount || 0}
                  onChange={(e) => handlePaymentMethodChange(paymentMethod.id, 'max_amount', parseFloat(e.target.value))}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">{paymentMethod.value}</InputAdornment>,
                  }}
                />
              </Grid>
              
              <Grid item xs={12}>
                <Divider sx={{ my: 1 }} />
                <Typography variant="subtitle2" gutterBottom>
                  ZPUB настройки
                </Typography>
                <TextField
                  fullWidth
                  label={`${paymentMethod.value} ZPUB`}
                  value={getZpubValue(paymentMethod)}
                  onChange={(e) => handleZpubChange(`${paymentMethod.value}_ZPUB`, e.target.value)}
                  multiline
                  rows={2}
                  helperText="При изменении ZPUB автоматически сбрасываются деривации"
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default CryptoCurrencySetting; 